import React from 'react'
import { HeaderBackButton } from '@react-navigation/elements'
import { createStackNavigator } from '@react-navigation/stack'
import { View, Image } from 'react-native'

import { useContent } from '@sart/content'
import { Text } from '@sart/components'
import { backgroundColors, theme, colors } from "@sart/styles"
import Transfer from './Transfer'
import TransferCaptureNumber from './TransferCaptureNumber'
import Transform from './Transform'
import Confirmation from '../Confirmation'
import { stackNavigationProps } from '../nagivationProps'
import GiftSwapMenu from './GiftSwapMenu'
import { CompanyIcon } from '@sart/icons'
const Stack = createStackNavigator()

function GiftSwapStackNavigator() {

  const content = useContent()

  return(
    <Stack.Navigator
      initialRouteName='GiftSwapMenu'
      screenOptions={{
        ...stackNavigationProps.screenOptions
      }}
    >
      <Stack.Screen
        name="GiftSwapMenu"
        component={GiftSwapMenu}
        options={{
          title: "",
          headerLeft: () => (<View style={{paddingLeft: 15}}>
            <Image
                source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
                height={45} width={45}
            />
          </View>)
        }}
      />
      <Stack.Screen
        name="Transfer"
        component={TransferCaptureNumber}
        options={{
          title: content.transfer.giftTo,
          headerCenter: () => <Text style={theme.navigationHeader}>{content.transfer.giftTo}</Text>,
          headerTitleStyle: theme.navigationHeader,
          headerRight: () => (<View/>)
        }}
      />
      <Stack.Screen
        name="TransferMenu"
        component={Transfer}
        options={{
          title: content.transfer.giftAmount,
          headerCenter: () => <Text style={theme.navigationHeader}>{content.transfer.giftAmount}</Text>,
          headerTitleStyle: theme.navigationHeader,
          headerRight: () => (<View/>)
        }}
      />
      <Stack.Screen
        name="Transform"
        component={Transform}
        options={{
          title: content.menu.transform,
          headerCenter: () => <Text style={theme.navigationHeader}>{content.menu.transform}</Text>,
          headerTitleStyle: theme.navigationHeader,
          headerRight: () => (<View/>)
        }}
      />
      <Stack.Screen
        name="Confirmation"
        component={Confirmation}
        options={({ navigation }) => ({
          title: '',
          headerLeft: props => (
            <HeaderBackButton
              {...props}
              label={content.navigation.dashboard}
              onPress={() => {
                navigation.popToTop()
                navigation.navigate('Dashboard')
              }}
              tintColor={colors.clear}
            />
          ),
          headerTitleStyle: theme.navigationHeader,
          headerStyle: {
            backgroundColor: colors.srDarkGreen,
            borderBottomWidth: 0,
            elevation: 0
          },
          headerRight: () => (<View/>)
        })}
      />
    </Stack.Navigator>
  )
}

export default GiftSwapStackNavigator
